<template>
  <div :style="wrapperStyle">
    <label v-if="fieldLabel" class="form-field-label">{{ fieldLabel }}</label>
    <label class="form-field-label" :for="uniqueTitle + '-start'">Start</label>
    <input :id="uniqueTitle + '-start'" class="form-control mb-2" type="datetime-local" :value="start" :disabled="isReadonly" @input="onStart" />
    <label class="form-field-label" :for="uniqueTitle + '-end'">End</label>
    <input :id="uniqueTitle + '-end'" class="form-control" type="datetime-local" :value="end" :disabled="isReadonly" @input="onEnd" />
    <div v-if="summary" class="duration-summary">{{ summary }}</div>
    <input type="hidden" :name="uniqueTitle" :value="stored" />
  </div>
</template>

<script>
import { inject, computed } from 'vue'
import { formattingToStyle } from '../../lib/client-rule-evaluator'
import { durationBetween, durationUnit, formatDuration } from '../../../../shared/duration-column'

function localInput (value) {

  if (!value) return ''

  const date = new Date(value)

  if (Number.isNaN(date.getTime())) return String(value).slice(0, 16)

  const pad = (part) => String(part).padStart(2, '0')

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}

export default {
  props: ['uniqueTitle', 'fieldLabel', 'description', 'durationUnit'],
  setup (props) {

    const formFormatting = inject('formFormatting', null)
    const formReadonly = inject('formReadonly', null)
    const formValues = inject('formValues', null)
    const updateFormValue = inject('updateFormValue', null)

    const wrapperStyle = computed(() => {
      if (!formFormatting || !props.uniqueTitle) return {}
      const fmt = formFormatting[props.uniqueTitle]
      return fmt ? formattingToStyle(fmt) : {}
    })

    const isReadonly = computed(() => {
      if (!formReadonly || !props.uniqueTitle) return false
      return !!formReadonly[props.uniqueTitle]
    })

    return { formValues, updateFormValue, wrapperStyle, isReadonly }
  },
  data () {
    return {
      start: '',
      end: '',
      stored: ''
    }
  },
  computed: {
    unit () {
      return durationUnit({ durationUnit: this.durationUnit })
    },
    summary () {
      if (!this.start || !this.end) return ''
      const amount = durationBetween(this.start, this.end, this.unit)
      if (amount == null) return ''
      if (amount < 0) return 'The end is before the start.'
      return formatDuration(amount, this.unit)
    }
  },
  mounted () {
    this.readExisting()
  },
  methods: {
    readExisting () {
      if (!this.formValues || !this.uniqueTitle) return
      this.start = localInput(this.formValues[`${this.uniqueTitle}_start`])
      this.end = localInput(this.formValues[`${this.uniqueTitle}_end`])
      this.writeStored()
    },
    onStart (event) {
      this.start = event.target.value
      this.writeStored()
    },
    onEnd (event) {
      this.end = event.target.value
      this.writeStored()
    },
    writeStored () {
      if (!this.start && !this.end) {
        this.stored = ''
        if (this.updateFormValue) this.updateFormValue(this.uniqueTitle, '')
        return
      }
      const payload = { start: this.start, end: this.end }
      this.stored = JSON.stringify(payload)
      if (this.updateFormValue) this.updateFormValue(this.uniqueTitle, payload)
    }
  }
}
</script>

<style scoped>
.duration-summary {
  margin-top: 6px;
  color: #3d4a34;
  font-size: 0.9rem;
}
</style>
